__webpack_require__.p = "https://clarynext.webapp-dev.com/";